import ApiaApi, {
  makeApiaUrl,
} from '../../../../../../../../api/apiaApi/apiaApi';
import { IAttachment } from '@apia/ai';

export async function generateFormsContent(
  // formsData: ReturnType<typeof getFormsInformation>,
  action: string,
  prompt?: string,
  files?: IAttachment[],
) {
  const url = makeApiaUrl({
    action,
    ajaxUrl: 'apia.execution.FormAction.run',
    frmParent: window.ApiaFunctions.getAllForms().some((f) => {
      f.type === 'E';
    })
      ? 'E'
      : 'P',
  });

  return ApiaApi.post<{ json: string }>(url, {
    postData: {
      ...(prompt ? { prompt } : {}),
      // ...(formsData.prevContext ? { prevContext: formsData.prevContext } : {}),
      // ...(formsData.enumValues
      //   ? { enumValues: JSON.stringify(formsData.enumValues) }
      //   : {}),
      files: JSON.stringify(
        files?.map((a) => {
          return {
            base64: a.base64,
            name: a.name,
            description: a.description ?? '',
          } as {
            name: string;
            base64: string;
            description: string;
          };
        }),
      ),
    },
    postDataTreatement: 'stringify',
  });
}
